import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessUserProvider {
	url: any;
	token: any;
	users: any = [{Id:0}];

	constructor(  		
		public http: Http,
		public globals: Globals,
	  	public storage: Storage,
	  	public httpHelper: HttpHelper
		) {    
	}

	updateUser(user){
		for (var i = this.users.length - 1; i >= 0; i--) {
			if(this.users[i].Id==user.Id){
				Object.assign(this.users[i], user);														
				break;
			}			
		}
	}			

	deleteUserFromList(id){
		for (var i = this.users.length - 1; i >= 0; i--) {
			if(this.users[i].Id==id){
				this.users.splice(i, 1);												
				break;
			}			
		}
	}			

	save(params){
	    this.url = this.globals.dataUrl + 'businessUser/whiskey/' + this.globals.whiskeyId;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

	      	if(params.data.Id>0){
			    this.http
			    .put(
			      this.url, 
			      params.data, 
			      this.httpHelper.configOptionsWithToken(this.token)
			    )
			    .map(res => res.json())
			    .subscribe(response => {
			    	this.updateUser(response.Data);

					if(typeof params.cb == "function") params.cb(response);	        
			    });  
	      	}else{
			    this.http
			    .post(
			      this.url, 
			      params.data, 
			      this.httpHelper.configOptionsWithToken(this.token)
			    )
			    .map(res => res.json())
			    .subscribe(response => {
			    	this.refreshUsers(()=>{
			    		if(typeof params.cb == "function") params.cb(response);
			    	});			        
			    });  
	      	}
		})           
	}	

	udpateUserActivity(params){
		this.url = this.globals.dataUrl + 'businessUser/activity';

	    this.http
	    .post(
	      this.url, 
	      params.data, 
	      this.httpHelper.configOptionsWithToken(this.token)
	    )
	    .map(res => res.json())
	    .subscribe(response => {
	    	this.refreshUsers(()=>{
	    		if(typeof params.cb == "function") params.cb(response);
	    	});			        
	    });  		
	}

	deleteUser(params){
	    this.url = this.globals.dataUrl + 'businessUser/' + params.Id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .delete(
		      this.url, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		    	if(response.Success==true){
		    		this.deleteUserFromList(params.Id);
		    	}
		    	
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})    		
	}

	refreshUsers(cb){
		this.url = this.globals.dataUrl + 'businessUser/search';
										  
		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		  	this.users = res.Data;

		  	if(cb) cb(res.Data);
		  });   
		})
	}

	changePassword(params){
	    this.url = this.globals.dataUrl + 'businessUser/password';

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params.data, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}	

	getUsers(params){	
		this.url = this.globals.dataUrl + 'businessUser/search?term=' + params.term;
										  
		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		  	this.users = res.Data;

		  	if(params.cb) params.cb(res.Data);
		  });   
		})
	}  	

}



// WEBPACK FOOTER //
// ./src/providers/business-user.ts